import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppealAttachRow',
    props: {
        uploading: { type: Boolean, default: false },
        generating: { type: Boolean, default: false }
    },
    emits: ["pick", "regenerate"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_col = _resolveComponent("v-col");
            return (_openBlock(), _createBlock(_component_v_col, {
                cols: "auto",
                class: "d-flex align-center pa-0"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                        tag: "label",
                        variant: "tonal",
                        color: "primary",
                        rounded: "",
                        "prepend-icon": "mdi-paperclip",
                        loading: __props.uploading,
                        disabled: __props.generating
                    }, {
                        default: _withCtx(() => [
                            _cache[2] || (_cache[2] = _createTextVNode(" Attach a document ", -1)),
                            _createElementVNode("input", {
                                type: "file",
                                accept: ".pdf,.tif,.tiff,.png,.jpg,.jpeg",
                                class: "d-none",
                                onChange: _cache[0] || (_cache[0] = (event) => emit('pick', event))
                            }, null, 32)
                        ]),
                        _: 1
                    }, 8, ["loading", "disabled"]),
                    _createVNode(_component_v_btn, {
                        variant: "text",
                        color: "primary",
                        class: "ml-2",
                        "prepend-icon": "mdi-refresh",
                        loading: __props.generating,
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('regenerate')))
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Regenerate ", -1)
                            ]))]),
                        _: 1
                    }, 8, ["loading"])
                ]),
                _: 1
            }));
        };
    }
});
